"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowBack = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const ArrowBack = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5901 4.8728C10.7913 4.67764 10.7964 4.35607 10.6015 4.15456C10.4066 3.95305 10.0855 3.94791 9.88431 4.14307L2.15434 11.6402C2.05565 11.7359 1.99995 11.8677 2 12.0053C2.00005 12.1428 2.05583 12.2745 2.15459 12.3702L9.88456 19.8572C10.0859 20.0522 10.407 20.0468 10.6018 19.8452C10.7965 19.6435 10.7912 19.322 10.5898 19.127L3.75294 12.505H21.5008C21.7766 12.505 22.0001 12.2811 22.0001 12.005C22.0001 11.7289 21.7766 11.505 21.5008 11.505H3.75189L10.5901 4.8728Z"
    })
  });
};
exports.ArrowBack = ArrowBack;